
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer: React.FC = () => {
  return (
    <footer className="py-4">
      <Container className="text-center">
        <p>&copy; 2025 Andrei Skopenko</p>
      </Container>
    </footer>
  );
};

export default Footer;
